goog.provide("shadow.js.shim.module$$mui$material$Checkbox$default");
shadow.js.shim.module$$mui$material$Checkbox$default = shadow.js.shim.module$$mui$material$Checkbox.default;
